import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { IVisitorAgreementListProps, IVisitorAgreementListItem } from './types';

export const VisitorAgreementList: React.FC<IVisitorAgreementListProps> = ({
  agreements,
}) => {
  const renderListItem = (agreement: IVisitorAgreementListItem) => (
    <tr key={agreement.id}>
      <td>
        <Link to={`/admin/visitorAgreements/${agreement.id}`}>
          {agreement.name}
        </Link>
      </td>
      <td>{agreement.useDigitalSignature ? 'Yes' : 'No'}</td>
    </tr>
  );

  return (
    <Table hover>
      <thead>
        <tr>
          <th>Name</th>
          <th>Digital Signature</th>
        </tr>
      </thead>
      <tbody>{agreements.map(renderListItem)}</tbody>
    </Table>
  );
};
